import axios from 'axios';
import store from '@/_shared/store';
import router from '@/_shared/router';

const getToken = () => window.localStorage.getItem("token");

export const defaultConfig = {
  baseURL: process.env.BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
};

const httpClient = axios.create(defaultConfig);

httpClient.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${getToken()}`;
  return config;
});

const _setRole = (response) => {
  const roleWasReturned = response.data.meta && response.data.meta.role;
  const roleDefined = !!store.state.user.role;
  if (roleWasReturned && !roleDefined) {
    store.commit('setRole', response.data.meta.role);
  }
  return response;
};

const _handleResponseError = (error) => {
  const tokenIsInvalid = error.response.status === 401;
  if (tokenIsInvalid) {
    localStorage.removeItem('token');
    router.push('/login');
  }
  return Promise.reject(error);
};

httpClient.interceptors.response.use(_setRole, _handleResponseError);

export default httpClient;



// WEBPACK FOOTER //
// ./src/_shared/http-client.js